import { useEffect } from 'react';
import { getBrandsThunk } from '../../api/brands';
import { setFilterValue } from '../../redux/sliceCreators/brandsSlice';

import { useAppDispatch } from '../../redux/store';
const SearchFormListener = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    document.addEventListener('searchFormSubmit', handleSearchBarSubmit);
    dispatch(getBrandsThunk());
    return () => {
      document.removeEventListener('searchFormSubmit', handleSearchBarSubmit);
    };
  }, []);

  const handleSearchBarSubmit = (args: any) => {
    const action = args.detail.action;
    const query = args.detail.query;
    if (action === 'searchBar' && typeof query === 'string') {
      dispatch(setFilterValue(query));
    }
  };

  return null;
};

export default SearchFormListener;
